import { request } from '@/utils/ajax';

export enum DismissibleMessageKey {
    SensitiveInfo = 'SensitiveInfo',
}

export function setMessageDismissal(key: DismissibleMessageKey, value: boolean, projectId: number | null) {
    return request(`api/message-dismissal/${encodeURIComponent(key)}`, {
        method: 'PUT',
        json: true,
        body: {
            projectId,
            value,
        },
    });
}

export function getMessageDismissalValue(key: DismissibleMessageKey, projectId: number | null): Promise<boolean> {
    return request(`api/message-dismissal/${encodeURIComponent(key)}`, { query: { projectId } }).then((x) => x.json());
}
